module.exports = __webpack_public_path__ + "img/calligraphy_fenbi.692fef32.png";